import React from 'react';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

function ContactPage() {
  return (
    <div className="page">
      <main>
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default ContactPage;
